// Define message types for RCON process
// Define message types for RCON process
export const RCON_MESSAGE_TYPES = {
  // Server -> Client Message Types (used in RconBruteModule)
  STATUS_UPDATE: 'RCON_STATUS_UPDATE',
  PROGRESS_UPDATE: 'RCON_PROGRESS_UPDATE', // Generic progress message
  PORT_SCAN_STARTED: 'RCON_PORT_SCAN_STARTED',
  PORT_FOUND: 'RCON_PORT_FOUND',
  PORT_SCAN_COMPLETED: 'RCON_PORT_SCAN_COMPLETED',
  PASSWORD_CRACK_STARTED: 'RCON_PASSWORD_CRACK_STARTED',
  PASSWORD_FOUND: 'RCON_PASSWORD_FOUND',
  PASSWORD_CRACK_FAILED: 'RCON_PASSWORD_CRACK_FAILED',
  RCON_CONNECTED: 'RCON_CONNECTED', // Maybe after password found
  RCON_COMMAND_RESPONSE: 'RCON_COMMAND_RESPONSE', // For command execution
  BRUTE_STOPPED: 'RCON_BRUTE_STOPPED', // Explicit stop message (CHANGED from RCON_BRUTE_STOP for consistency)
  SERVER_HACKED: 'RCON_SERVER_HACKED', // Explicit success message
  PASSWORD_BASES_LIST: 'RCON_PASSWORD_BASES_LIST', // New: Server sends list of bases

  // Error Types (Server -> Client)
  ERROR: 'RCON_ERROR',
  PORT_INCORRECT: 'RCON_PORT_INCORRECT',
  DATA_INCORRECT: 'RCON_DATA_INCORRECT',
  PERMISSION_ERROR: 'RCON_PERMISSION_ERROR',
  CONFIG_ERROR: 'RCON_CONFIG_ERROR',

  // Client -> Server Message Types
  START_PROCESS: 'RCON_START', // Single start type
  STOP_PROCESS: 'RCON_STOP',
  EXECUTE_COMMAND: 'RCON_COMMAND',
  GET_PASSWORD_BASES: 'RCON_GET_PASSWORD_BASES', // New: Client requests list of bases
};

// WebSocket topics
export const RCON_TOPICS = {
  // Destinations for messages from Client -> Server (prefixed with /app by WebSocketProvider)
  APP_ENDPOINT_BASE: '/rcon', // Base destination for RCON actions
  APP_START: '/start',        // Destination for starting the scan/crack process
  APP_STOP: '/stop',          // Destination for stopping the process
  APP_COMMAND: '/command',    // Destination for sending RCON commands (if implemented)
  APP_GET_BASES: '/get-bases', // New: Destination for requesting password bases
  APP_MANUAL_CONNECT: '/manual-connect', // New: Destination for manual RCON connection attempts

  // User-Specific Subscription Topics (Server -> Client)
  USER_QUEUE_BASE: '/user/queue/rcon', // Base path for user-specific messages
  USER_PROGRESS: '/progress',        // For status, progress updates, ports found, base list
  USER_RESULT: '/result',            // For final outcomes (password found, stopped, hacked, crack failed)
  USER_ERROR: '/error',              // For specific RCON errors
  // USER_RESPONSE: '/response'      // Potential topic for RCON command responses
};

/**
 * Builds the full application endpoint path for RCON actions.
 * @param {string} action - The relative action path (e.g., RCON_TOPICS.APP_START).
 * @returns {string} The logical STOMP destination path (e.g., '/rcon/start').
 */
export const getRconAppEndpoint = (action) => {
  return `${RCON_TOPICS.APP_ENDPOINT_BASE}${action}`;
};

/**
 * Builds the full user-specific queue topic path for RCON subscriptions.
 * @param {string} subTopic - The relative sub-topic path (e.g., RCON_TOPICS.USER_PROGRESS).
 * @returns {string} The full user-specific STOMP topic path (e.g., '/user/queue/rcon/progress').
 */
export const getRconUserQueueTopic = (subTopic) => {
    return `${RCON_TOPICS.USER_QUEUE_BASE}${subTopic}`;
};